module.exports = {"footer-powered-by":"Vue-Typescript-boilerplate {version}.{build} powered by Vue","hello-essential-links":"Essential Links","hello-ecosystems":"Ecosystem","navbar-title":"Vue-boilerplate"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en.json
// module id = yF0G
// module chunks = 1